import { useSelector } from "react-redux";
import { useState } from "react";
import { Box, styled, useMediaQuery, useTheme } from "@mui/material";
import WebTabs from "./components/WebTabs";
import MobileTabs from "./components/MobileTabs";
import { RootState } from "../common/redux/store";
import { getTabSections } from "./utils/getTabSections";

const ManageDocumentsPage = () => {
    const userData = useSelector((state: RootState) => state.user.data);
    const [currentTab, setCurrentTab] = useState(0);

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

    if (!userData) return null;

    return (
        <Container flexdirection={isDesktop ? "row" : "column"}>
            {isDesktop ? (
                <Box sx={{ display: "flex", flex: 1 }}>
                    <WebTabs
                        currentTab={currentTab}
                        onTabChange={setCurrentTab}
                    />
                    <Box
                        sx={{
                            flex: 1,
                            padding: 2,
                            marginTop: "38px",
                        }}
                    >
                        {getTabSections(currentTab)}
                    </Box>
                </Box>
            ) : (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        overflow: "hidden",
                    }}
                >
                    <MobileTabs
                        currentTab={currentTab}
                        onTabChange={setCurrentTab}
                    />
                    <Box
                        sx={{
                            flex: 1,

                            padding: 2,
                        }}
                    >
                        {getTabSections(currentTab)}
                    </Box>
                </Box>
            )}
        </Container>
    );
};

export default ManageDocumentsPage;

interface ContainerProps {
    flexdirection: "row" | "column";
}

const Container = styled(Box)<ContainerProps>(({ flexdirection }) => ({
    display: "flex",
    flexDirection: flexdirection,
    height: "auto",
    width: "100%",

    "@media( width >= 1024px)": {
        height: "calc(100vh - 64px)",
    },
}));
